import React from 'react';
import styled from 'styled-components';

interface ButtonProps {
  children: React.ReactNode;
  backgroundColor?: string;
  textColor?: string;
  maxWidth?: string;
  href?: string;
  newTab?: boolean;
  onClick?: () => void;
  type?: string;
  id?: string;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  backgroundColor = '#283288',
  textColor = '#fff',
  maxWidth = '100%',
  href,
  newTab = false,
  onClick,
  type,
  id,
  className,
}) => {
  if (href) {
    return (
      <StyledLink
        backgroundColor={backgroundColor}
        textColor={textColor}
        maxWidth={maxWidth}
        href={href}
        target={newTab ? '_blank' : '_self'}
        rel={newTab ? 'noopener noreferrer' : undefined}
        onClick={onClick}
        type={type}
        id={id}
        className={className}
      >
        {children}
      </StyledLink>
    );
  }

  return (
    <StyledButton
      onClick={onClick}
      backgroundColor={backgroundColor}
      textColor={textColor}
      maxWidth={maxWidth}
      id={id}
    >
      {children}
    </StyledButton>
  );
};

interface StyledProps {
  backgroundColor: string;
  textColor: string;
  maxWidth: string;
}

const baseStyles = `
  all:unset;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 20px;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.2s ease, transform 0.2s ease;
`;

const StyledButton = styled.button<StyledProps>`
  ${baseStyles}
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  max-width: ${({ maxWidth }) => maxWidth};

  @media (min-width: 768px) {
    font-size: 20px;
  }

  @media (min-width: 1024px) {
    font-size: 25px;
  }

  &:hover {
    background-color: ${({ backgroundColor }) => darkenColor(backgroundColor, 0.08)};
    transform: scale(1.05); /* escala el botón */
  }
`;

const StyledLink = styled.a<StyledProps>`
  ${baseStyles}
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  max-width: ${({ maxWidth }) => maxWidth};

  @media (min-width: 768px) {
    font-size: 20px;
  }

  @media (min-width: 1024px) {
    font-size: 25px;
    padding: 5px 20px;
  }

  &:hover {
    background-color: ${({ backgroundColor }) => darkenColor(backgroundColor, 0.08)};
    transform: scale(1.05); /* escala el botón */
  }
`;

function darkenColor(hex: string, amount: number) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.max(0, (num >> 16) - 255 * amount);
  const g = Math.max(0, ((num >> 8) & 0x00ff) - 255 * amount);
  const b = Math.max(0, (num & 0x0000ff) - 255 * amount);
  return `rgb(${r},${g},${b})`;
}
